import { TelemetryLine, TelemetryLineParams } from '@shared/interfaces/telemetry';
import { ChartOptions } from 'chart.js';
import { getThemeColor } from '../../../../utils/color/color';
import { fillMissingDates } from '../../../../utils/date/date';

export const createLine = (graph: TelemetryLine) => {
  return {
    type: 'line' as const,
    title: graph.title,
    options: createOptions(graph.params, isDateGraph(graph.data)),
    data: buildChartData(graph.data, graph.params.color),
    height: 300,
    plugins: [],
  };
};

const isDateGraph = (data: TelemetryLine['data']) => {
  const indexName = Object.keys(data[0]).filter((name) => name !== 'count')[0];
  const firstValue = data[0][indexName].toString();
  return !Number.isNaN(Date.parse(firstValue));
};

const buildChartData = (data: TelemetryLine['data'], color: string | null) => {
  const indexName = Object.keys(data[0]).filter((name) => name !== 'count')[0];
  let chartData = data.map((el) => ({ date: el[indexName].toString(), count: el.count }));
  if (isDateGraph(data)) {
    const start = new Date(chartData[0].date);
    const end = new Date(chartData[chartData.length - 1].date);
    chartData = fillMissingDates(chartData, start, end);
  }
  return {
    datasets: [
      {
        data: chartData.map((el) => el.count),
        borderColor: getThemeColor(color),
        backgroundColor: `${getThemeColor(color)}33`,
        fill: true,
      },
    ],
    labels: chartData.map((el) => el.date),
  };
};

const createOptions = (options: TelemetryLineParams, isDateGraph: boolean): ChartOptions<'line'> => {
  const res: ChartOptions<'line'> = {
    maintainAspectRatio: false,
    responsive: true,
    animation: false,
    scales: {
      x: {
        title: { text: options.labels[options.x], display: true, font: { weight: 'bold' } },
      },
      y: {
        title: { text: options.labels[options.y], display: true, font: { weight: 'bold' } },
      },
    },
    plugins: {
      legend: { display: false },
    },
  };
  if (isDateGraph) {
    res.scales!['x'] = {
      title: { text: options.labels[options.x], display: true, font: { weight: 'bold' } },
      type: 'time' as const,
      time: { unit: 'day', displayFormats: { day: 'DD.MM' } },
      ticks: { maxRotation: 0 },
    };
  }
  return res;
};
